import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Platform } from "@ionic/angular";

import { UserInterface } from "../types/user";
import createGuest from "cross-domain-storage/guest";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { isPlatformBrowser } from "@angular/common";

export const storageKeySSO: string = "hypropUser";
export const storageKeySSOToken: string = "hypropToken";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  user: UserInterface = undefined;
  registeringUser: UserInterface = undefined;
  accessToken: string | null = null;
  xhrInProgress: boolean = false;
  autoLoggedIn: boolean = false;
  cordova: boolean = false;
  isBrowser: boolean = false;
  ssoProfile;
  redirectUrl: string = null;

  dataChange: Subject<any> = new Subject<any>();

  constructor(
    private platform: Platform,
    public http: HttpClient,
    @Inject(PLATFORM_ID) platformId: string
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser) {
      this.ssoProfile = createGuest(environment.sso_url);

      this.ssoProfile.get(storageKeySSOToken, (error, token) => {
        if (!error && token) {
          this.accessToken = token;

          if (!this.xhrInProgress && !this.autoLoggedIn) {
            this.xhrInProgress = true;

            this.autoLoggedIn = true;

            if (this.isBrowser) {
              this.ssoProfile.get(storageKeySSO, (error, user) => {
                if (!error && user) {
                  this.setUser(JSON.parse(user));
                }
              });
            }

            //Execute PUT request with error handler
            this.http
              .put(
                environment.api_base_url + "shoppers/tracking/log",
                {
                  action: "login",
                  title: "Logged in to " + environment.environment_name,
                  url:
                    window && typeof window !== "undefined"
                      ? window.location.href
                      : this.platform.is("android")
                      ? "android"
                      : this.platform.is("ios"),
                  mallId: environment.mall_id,
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + token,
                  },
                }
              )
              .subscribe({
                next: () => {},
              });
          }
        }
      });
    }

    this.platform.ready().then(() => {
      this.cordova = this.platform.is("cordova");
    });
  }

  isAuthenticated() {
    return !!this.accessToken;
  }

  logOut() {
    this.user = undefined;

    if (this.isBrowser) {
      this.ssoProfile.remove(storageKeySSOToken);
      this.ssoProfile.remove(storageKeySSO);
    }
  }

  setUser(user: UserInterface) {
    this.user = user;

    if (!this.cordova && this.isBrowser && this.user.email) {
      this.ssoProfile.set(storageKeySSO, JSON.stringify(user), () => {});
    }

    this.dataChange.next(this.user);
  }

  setRegisteringUser(user: UserInterface) {
    this.registeringUser = user;
    this.dataChange.next(this.registeringUser);
  }

  getUser() {
    return this.user;
  }

  getRegisteringUser() {
    return this.registeringUser;
  }

  getUserToken() {
    return this.accessToken;
  }

  setUserToken(token) {
    this.accessToken = token;

    if (!this.cordova && this.isBrowser && token) {
      this.ssoProfile.set(storageKeySSOToken, token, () => {});
    }
  }

  updateUser(userData) {
    this.setUser({ ...this.user, ...userData });
  }

  setRedirectUrl(url) {
    this.redirectUrl = url;
  }

  getRedirectUrl() {
    return this.redirectUrl;
  }
}
